import React, { useEffect, useState } from 'react';


const New3 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
      <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
      <h1 className="text-[15px] md:text-[32px] font-bold mb-4 text-black">Revolutionizing Agriculture with Digital solutions</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744560910/image-3_lkomux.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
       
        </div>
      </div>

      <div className='px-1'>
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[10px] md:text-[30px]">March 03, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[10px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  <h3 className="text-black font-bold text-[10px] md:text-[32px] mt-5">Women in Agriculture - Namibia</h3>

  {/* Main Text Section */}
  <div className="mt-5 space-y-8">
    <p className="text-[10px] md:text-[32px] text-black font-normal">
      Women play a pivotal role in Namibia's agricultural sector, significantly contributing to food security, economic development, and community resilience. Despite their substantial involvement, challenges such as limited access to resources, decision-making platforms, and financial services persist.
    </p>

    <p className="text-[10px] md:text-[32px] text-black font-normal">
      <span className='font-black'>Ownership and Participation</span><br/>
      <strong className='font-bold'>Farm Ownership:</strong> Recent data indicates that approximately 30% of horticulture farmers in Namibia are women, highlighting their active participation in this sector. However, gender disparities are evident in commercial farming, where women own only 24% of commercial farms, leaving 76% under male ownership. <br />
      <strong className='font-bold'>Diverse Agricultural Activities:</strong> Women engage in various farming activities, including crop cultivation, livestock rearing, and poultry farming. For instance, Ellenora Muranda, a part-time farmer in the Tsumeb district, manages a diverse range of crops and livestock, supplying produce to local retailers.<br />
      <strong className='font-bold'>Empowerment Initiatives</strong><br />

      <strong className='font-bold'>Training and Capacity Building:</strong> Programs such as the agribusiness bootcamp, launched by GIZ in collaboration with StartUp Namibia, aim to equip women with essential business and agricultural skills. The inaugural session in September 2022 trained 12 entrepreneurs, enhancing their capabilities in urban agriculture and business management.<br />
      <strong className='font-bold'>Government Support:</strong> The Namibian government acknowledges women's critical role in agriculture, implementing initiatives like the dryland crop production program and the horticulture support and value chain development project. In the 2021/22 season, these programs benefited 44,959 farmers, with women constituting 50% of the beneficiaries, providing access to inputs, mechanized services, and irrigation materials.<br />
      <strong className='font-bold'>Challenges and Advocacy</strong><br />

      <strong className='font-bold'>Access to Resources:</strong> Women often face barriers in accessing land, credit, and productive resources, limiting their agricultural potential. Addressing these disparities is crucial for promoting gender equality and enhancing agricultural productivity.<br/>
      <strong className='font-bold'>Gender Equality Efforts:</strong> The Women and Agriculture Summit in October 2023 emphasized the need for gender equality and innovation in agriculture. Discussions focused on promoting women's land rights, financial inclusion, and the adoption of technology to improve productivity and attract younger generations to farming. <br />
      <strong className='font-bold'>Success Stories</strong><br />
      <strong className='font-bold'>Eudafano Women's Cooperative:</strong> Established over two decades ago, this cooperative empowers around 2,500 women through the sustainable harvesting and processing of marula fruits. Their products, such as marula oil, are sold internationally, enhancing the women's economic status and promoting biodiversity conservation. In summary, Namibian women are indispensable to the agricultural landscape, driving both economic growth and food security. Continued efforts to address existing challenges and promote gender equality are essential for unlocking their full potential and ensuring a prosperous agricultural future.<br/>
    </p>
  </div>

  <div className='md:h-10 h-4'></div>
</div>


    </div>
   </div>
  );
};

export default New3;
